import React, { Suspense, createContext, lazy, useEffect, useState } from "react";
import { RoomToDoErrorBoundary } from "../../Project/ProjectChildComponent/RoomToDoTab";
import { taskRoomOf } from "../cockpitNavigation";

const ToDo = lazy(() => import("../../Feeds/ToDo"));

/**
 * Inside the cockpit: open a task ({ todoId, roomId, roomName }) on the cockpit
 * itself. Lists outside the cockpit (the project's Übersicht) have no provider
 * and keep opening the task inside its project.
 */
export const CockpitTaskContext = createContext(null);

/**
 * One task's detail on the cockpit — the project pane's ToDo with only the
 * detail shown. Closing it (or deleting the task) calls onClose.
 */
export default function CockpitTaskView({ task, strings, onClose }) {
  const todoId = task && task.todoId != null ? String(task.todoId) : null;
  const knownRoom = task && task.roomId != null && task.roomId !== "" ? { id: String(task.roomId), name: task.roomName || "" } : null;
  const [room, setRoom] = useState(knownRoom);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    if (knownRoom || !todoId) return undefined;
    let cancelled = false;
    setRoom(null);
    setMissing(false);
    taskRoomOf(todoId).then((found) => {
      if (cancelled) return;
      if (found) setRoom({ id: found.id, name: task.roomName || found.name });
      else setMissing(true);
    });
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [todoId]);

  return (
    <section className="cockpit-task-view">
      {room ? (
        <RoomToDoErrorBoundary strings={strings}>
          <Suspense fallback={null}>
            <ToDo embedded embeddedRoomId={room.id} embeddedRoomName={room.name} openTodoId={todoId} onCloseTask={onClose} />
          </Suspense>
        </RoomToDoErrorBoundary>
      ) : missing ? (
        <div className="cockpit-task-view-empty">{strings.pro_todo_not_found || "Diese Aufgabe ist nicht mehr verfügbar."}</div>
      ) : null}
    </section>
  );
}
